.<template>
  <base-crud
    crudName="Salas de Reunião"
    newText="Nova Sala de Reunião"
    :table="table"
    :columns="columns"
    :options="options"
    :endPoint="endPoint"
    :enableAdd="true"
    :enableEdit="true"
    :enableDelete="true"
    :enableView="true"
    :dataForm="dataForm"
  />
</template>

<script>
import BaseCrud from "../Base/BaseCrud";
export default {
  data: function() {
    return {
      table: "rooms",
      columns: [
        "id",
        "photo",
        "qrcodeid",
        "title",
        "tag",
        "company_id",
        "floor",
        "number_room",
        "capacity",
        "actions"
      ],
      tableData: [
        "id",
        "photo",
        "qrcodeid",
        "title",
        "tag",
        "company_id",
        "floor",
        "number_room",
        "capacity"
      ],
      options: {
        filterable: [
          "id",
          "title",
          "tag",
          "floor",
          "company_id",
          "number_room",
          "capacity"
        ],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        filterByColumn: true,
        debounce: 1000,
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          photo: "Foto",
          qrcodeid: "QRCode",
          title: "Titulo",
          tag: "Tag",
          company_id: "Empresa",
          floor: "Andar",
          number_room: "Nº da Sala",
          capacity: "Qtd de Pessoas",
          actions: "Ações"
        },

        templates: {
          company_id: function(h, row, index) {
            return row.company ? row.company.company_name : "Sem Nome";
          },          
          qrcodeid: function(h,row,index){
            return 'room-' + row.qrcodeid
          }
        },
        requestFunction: function(data) {
          let requestData = {};
          let query = this.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["company"];
          return this.$http.get(this.url + "?" + query, requestData).catch(
            function(e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        }
      },
      endPoint: "rooms/",
      dataForm: {}
    };
  },
  components: {
    BaseCrud
  },
  methods: {
    query: function(query) {
      let columns = {
        id: "id",
        photo: "photo",
        title: "title",
        tag: "tag",
        company_id: "company[company_name]",
        floor: "floor",
        number_room: "number_room",
        capacity: "capacity"
      };
      let filters = "";
      $.each(query, function(index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    }
  }
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/Rooms/Crud.vue